import { type HttpClientConfig, type HttpClientInterface } from './http/HttpClient'

type AttachmentRepositoryDependencies = {
  httpClient: HttpClientInterface
}

type AttachmentLink = {
  file_url: string
}

export type AttachmentRequestBody = { quoteUuid: string; attachmentId: number }

export class AttachmentRepository {
  private httpClient: HttpClientInterface

  constructor({ httpClient }: AttachmentRepositoryDependencies) {
    this.httpClient = httpClient
  }

  async getAttachmentURL(
    { quoteUuid, attachmentId }: AttachmentRequestBody,
    config?: Partial<HttpClientConfig>
  ): Promise<string> {
    const endpoint = `spot_quotes/${quoteUuid}/attachments/${attachmentId}/download`

    const response = await this.httpClient.get<AttachmentLink>(endpoint, config)

    return response.data.file_url
  }
}
